import { Flex } from 'foundations-components/components/Flex';
import { useMemo, useState } from 'react';
import { ADD_ON_CARD } from '../../constants/tracking/TrackingSources';
import { PurchaseMotionCTAWrapper } from '../../containers/PurchaseMotionCTAWrapper';
import { useDisplayedCurrencyCode } from '../../hooks/pricing/useCurrencyDetails';
import { isTrackingSource, isValidPurchaseTerm } from '../../utils/typeguards';
import { AddOnQuantityStepper } from './AddOnQuantityStepper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AddOnCTA({
  productApiName,
  trackingData,
  productDetails,
  ownedQuantity,
  purchaseMotion,
  purchaseOption,
  isHubSpotCredits
}) {
  var _productDetails$packa, _productDetails$packa2, _productDetails$quant;
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const displayedCurrencyCode = useDisplayedCurrencyCode();
  const stepSize = isHubSpotCredits && productDetails !== null && productDetails !== void 0 && productDetails.packagedQuantitiesMap ? (_productDetails$packa = productDetails === null || productDetails === void 0 || (_productDetails$packa2 = productDetails.packagedQuantitiesMap) === null || _productDetails$packa2 === void 0 ? void 0 : _productDetails$packa2['HUBSPOT_CREDITS']) !== null && _productDetails$packa !== void 0 ? _productDetails$packa : 1 : 1;
  const quantifiable = (_productDetails$quant = productDetails === null || productDetails === void 0 ? void 0 : productDetails.quantifiable) !== null && _productDetails$quant !== void 0 ? _productDetails$quant : false;
  const maxTouchlessPurchasableQuantity = productDetails === null || productDetails === void 0 ? void 0 : productDetails.maxTouchlessPurchasableQuantity;
  const commitmentTerm = isValidPurchaseTerm(purchaseOption === null || purchaseOption === void 0 ? void 0 : purchaseOption.commitmentTerm) ? purchaseOption.commitmentTerm : undefined;
  const paymentTerm = isValidPurchaseTerm(purchaseOption === null || purchaseOption === void 0 ? void 0 : purchaseOption.paymentTerm) ? purchaseOption.paymentTerm : undefined;
  const maxPurchasableValue = maxTouchlessPurchasableQuantity == null ? Infinity : stepSize * maxTouchlessPurchasableQuantity;
  const canBuyMultiple = quantifiable && maxPurchasableValue > stepSize;
  const isDisabled = canBuyMultiple && selectedQuantity === 0;
  const trackingSource = isTrackingSource(trackingData.source) ? trackingData.source : ADD_ON_CARD;
  const purchaseRequest = useMemo(() => {
    const hasRequiredTerms = productDetails && commitmentTerm && paymentTerm;
    if (!hasRequiredTerms) {
      return {
        products: [],
        currencyCode: displayedCurrencyCode
      };
    }
    return {
      products: [{
        productApiName,
        incrementalQuantity: canBuyMultiple ? selectedQuantity : 1
      }],
      currencyCode: displayedCurrencyCode,
      commitmentTerm,
      paymentTerm
    };
  }, [productDetails, commitmentTerm, paymentTerm, productApiName, displayedCurrencyCode, canBuyMultiple, selectedQuantity]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "300",
    children: [/*#__PURE__*/_jsx(AddOnQuantityStepper, {
      productApiName: productApiName,
      quantity: selectedQuantity,
      onQuantityChange: setSelectedQuantity,
      trackingSource: trackingSource,
      productDetails: productDetails,
      ownedQuantity: ownedQuantity,
      stepSize: stepSize
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      gap: "200",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(PurchaseMotionCTAWrapper, {
        purchaseMotion: purchaseMotion,
        trackingData: trackingData,
        productApiName: productApiName,
        location: "MERCH_CARD",
        displayIndex: 0,
        purchaseRequest: purchaseRequest,
        skipInterstitial: true,
        disabled: isDisabled
      })
    })]
  });
}